import { render } from "./newAppointment.vue?vue&type=template&id=50930d93"
import script from "./newAppointment.vue?vue&type=script&lang=js"
export * from "./newAppointment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__